// Фільтр програм. Раніше тут стояли статуси «Опубліковано / Чернетка /
// Архівовано», яких у програм немає — у них лише прапорець «показувати на
// сайті», тож фільтр не міг спрацювати ніколи.
export const PROGRAMS_FILTERS = [
  {
    key: 'status',
    type: 'checkbox',
    label: 'Видимість',
    options: [
      { value: 'active', label: 'Показані на сайті' },
      { value: 'inactive', label: 'Приховані' },
    ],
  },
];

export const useProgramsFilters = () => PROGRAMS_FILTERS;
